
import {
  computed,
  defineComponent, inject, onBeforeMount, onBeforeUnmount, PropType, reactive, ref, Ref, toRefs, watch,
} from 'vue'
import {$padString, uuid} from '@/utils'
import {ALLOWED_SEPARATORS} from '@/pages/Manage/Catalogues/constants'
import {CtCatalogue} from '@/models/interfaces/content-type'
import { SkuController, SkuCtrl } from '@/pages/Manage/Catalogues/utils'
import { SKU_CAT_PAD_LENGTH, SKU_ID_PAD_LENGTH, SKU_PAD_CHAR } from '@/constants'

export default defineComponent({
  name: 'SkuSettingsField',
  components: {},
  props: {
    catalogue: {
      type: Object as PropType<CtCatalogue>,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      required: false,
    },
    separator: {
      type: String,
    },
    suffix: {
      type: String,
    },
    readonly: {
      type: Boolean,
    }
  },
  emits: ['update:editing', 'update:prefix', 'update:separator', 'update:suffix'],
  setup (props, {emit}) {

    const state = reactive({
    })


    const enableEditing = () => !props.editing && emit('update:editing', true)

    return {
      ...toRefs(state),
      padString: $padString,
      skuController: computed<SkuCtrl>(() => SkuController(props.catalogue)),
      enableEditing,
      ALLOWED_SEPARATORS,
      SKU_CAT_PAD_LENGTH, SKU_ID_PAD_LENGTH, SKU_PAD_CHAR
    }
  },

})
